var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "legalFQA", "data-role": "page" } },
    [
      _c(
        "div",
        {
          staticClass: "legalFQA-content",
          attrs: { "data-position": "fixed" }
        },
        [
          _c(
            "div",
            { staticClass: "swiper-container swiperTop", attrs: { id: "Top" } },
            [
              _c(
                "swiper",
                { ref: "Top", attrs: { options: _vm.swiperTop } },
                [
                  _c(
                    "swiper-slide",
                    {
                      staticClass: "swiper-slide selected",
                      attrs: { news_type: "all" }
                    },
                    [_vm._v("全部")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.news_tag, function(tag, tag_ind) {
                    return _c(
                      "swiper-slide",
                      {
                        key: tag_ind,
                        staticClass: "swiper-slide",
                        attrs: { news_type: tag.type_id }
                      },
                      [_vm._v(_vm._s(tag.type_name))]
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "swiper-container swiperPages",
              attrs: { id: "Pages" }
            },
            [
              _c(
                "swiper",
                {
                  ref: "Pages",
                  staticClass: "swiper-wrapper",
                  attrs: { options: _vm.swiperPages }
                },
                [
                  _c("swiper-slide", { staticClass: "swiper-slide" }, [
                    _c("div", { staticClass: "detailWrap" }, [
                      _c("div", { staticClass: "articleList" }, [
                        _c(
                          "ul",
                          _vm._l(_vm.news_list, function(news, news_ind) {
                            return _c(
                              "li",
                              { key: news_ind },
                              [
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "newsDetail",
                                        params: { id: news.news_id }
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "topicImg" }, [
                                      news.title_img != ""
                                        ? _c("div", {
                                            directives: [
                                              {
                                                name: "lazy",
                                                rawName:
                                                  "v-lazy:background-image",
                                                value: news.title_img,
                                                expression: "news.title_img",
                                                arg: "background-image"
                                              }
                                            ],
                                            staticClass: "mainImg"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      news.title_img == ""
                                        ? _c("div", { staticClass: "mainImg" })
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "txt-info" }, [
                                      _c(
                                        "span",
                                        { staticClass: "article_desc" },
                                        [_vm._v(_vm._s(news.title))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "article_date" },
                                        [
                                          _vm._v(
                                            _vm._s(news.news_date.split(" ")[0])
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "metaDiv" }, [
                                        _c("span", { staticClass: "cgy-tag" }, [
                                          _vm._v(
                                            _vm._s(_vm.chn_tag(news.news_type))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.Authority
                                          ? _c(
                                              "span",
                                              { staticClass: "bookmark-tag" },
                                              [
                                                _c("i", {
                                                  class: [
                                                    news.is_keep
                                                      ? "icon-bookmark-full active"
                                                      : "icon-bookmark",
                                                    "bookmarkIcon"
                                                  ],
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      _vm.SetFavorites(
                                                        news.news_id,
                                                        news.is_keep
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          })
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.news_tag, function(tag, tag_ind) {
                    return _c(
                      "swiper-slide",
                      { key: tag_ind, staticClass: "swiper-slide" },
                      [
                        _c("div", { staticClass: "detailWrap" }, [
                          _c("div", { staticClass: "articleList" }, [
                            _c(
                              "ul",
                              _vm._l(_vm.news_list, function(news, news_ind) {
                                return tag.type_id === news.news_type
                                  ? _c(
                                      "li",
                                      { key: news_ind },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "newsDetail",
                                                params: { id: news.news_id }
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "topicImg" },
                                              [
                                                news.title_img != ""
                                                  ? _c("div", {
                                                      directives: [
                                                        {
                                                          name: "lazy",
                                                          rawName:
                                                            "v-lazy:background-image",
                                                          value: news.title_img,
                                                          expression:
                                                            "news.title_img",
                                                          arg:
                                                            "background-image"
                                                        }
                                                      ],
                                                      staticClass: "mainImg"
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                news.title_img == ""
                                                  ? _c("div", {
                                                      staticClass: "mainImg"
                                                    })
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "txt-info" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "article_desc"
                                                  },
                                                  [_vm._v(_vm._s(news.title))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "article_date"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        news.news_date.split(
                                                          " "
                                                        )[0]
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "metaDiv" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "cgy-tag"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.chn_tag(
                                                              news.news_type
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.Authority
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "bookmark-tag"
                                                          },
                                                          [
                                                            _c("i", {
                                                              class: [
                                                                news.is_keep
                                                                  ? "icon-bookmark-full active"
                                                                  : "icon-bookmark",
                                                                "bookmarkIcon"
                                                              ],
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  _vm.SetFavorites(
                                                                    news.news_id,
                                                                    news.is_keep
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              })
                            )
                          ])
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("favoritesToast", {
        attrs: {
          show: _vm.toastControl.show,
          full: _vm.toastControl.full,
          content: _vm.toastControl.content,
          showTime: _vm.toastControl.showTime
        },
        on: {
          close: function($event) {
            _vm.toastControl.show = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-264b397a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264b397a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/news.vue
// module id = null
// module chunks = 